

const stringHelper = {
    methods: {
        // Converts a string to uppercase
        uppercase(str) {
            if (typeof str !== 'string') return '';
            return str.toUpperCase();
        },

        // Converts a string to lowercase
        lowercase(str) {
            if (typeof str !== 'string') return '';
            return str.toLowerCase();
        },

        // Converts a string to sentence case (first letter capitalized, rest lowercase)
        sentenceCase(str) {
            if (typeof str !== 'string') return '';
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },

        // Capitalizes the first letter of each word in a string
        capitalizeWords(str) {
            if (typeof str !== 'string') return '';
            return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        },

        // Removes leading and trailing whitespace from a string
        trim(str) {
            if (typeof str !== 'string') return '';
            return str.trim();
        },

        // Checks if a string is empty or contains only whitespace
        isEmpty(str) {
            if (typeof str !== 'string') return true;
            return str.trim().length === 0;
        },

        // Replaces all occurrences of a substring with another substring
        replaceAll(str, search, replacement) {
            if (typeof str !== 'string') return '';
            return str.split(search).join(replacement);
        },

        // Checks if a string contains a specific substring
        contains(str, search) {
            if (typeof str !== 'string') return false;
            return str.indexOf(search) !== -1;
        },

        // Extracts a substring from a string based on start and end indices
        substring(str, start, end) {
            if (typeof str !== 'string') return '';
            return str.substring(start, end);
        },

        // Extracts a substring from a string based on start index and length
        slice(str, start, length) {
            if (typeof str !== 'string') return '';
            return str.slice(start, start + length);
        },

        // Reverses a string
        reverse(str) {
            if (typeof str !== 'string') return '';
            return str.split('').reverse().join('');
        },

        // Counts the occurrences of a substring within a string
        countOccurrences(str, search) {
            if (typeof str !== 'string') return 0;
            let count = 0;
            let index = str.indexOf(search);
            while (index !== -1) {
                count++;
                index = str.indexOf(search, index + search.length);
            }
            return count;
        },

        //Truncates a string to a certain length and adds '...' to the end.
        truncate(str, length) {
            if (typeof str !== 'string') return '';
            if (str.length <= length) {
                return str;
            }
            return str.substring(0, length) + '...';
        },

        //Pad a string to a certain length with a specific character.
        pad(str, length, char = ' ') {
            if (typeof str !== 'string') return '';
            if (str.length >= length) {
                return str;
            }
            const padLength = length - str.length;
            return str + char.repeat(padLength);
        }
    }
};

export default stringHelper;
